export const KINFEED_TOPIC_TAGS = [
  {
    id: 'need-a-boost',
    label: 'Need a boost',
    description: 'When things feel heavy and you need a bit of care back.',
  },
  {
    id: 'small-wins',
    label: 'Small wins',
    description: 'For the good moments you want to share with other parents.',
  },
  {
    id: 'co-parenting',
    label: 'Co-parenting',
    description: 'Shared parenting, handovers, and the emotional logistics around them.',
  },
  {
    id: 'school-and-childcare',
    label: 'School & childcare',
    description: 'Nursery, school, childcare, routines, and the practical juggle.',
  },
  {
    id: 'work-and-money',
    label: 'Work & money',
    description: 'Income, bills, work pressures, and making things stretch.',
  },
  {
    id: 'local-tips',
    label: 'Local tips',
    description: 'Helpful nearby ideas, recommendations, and local finds.',
  },
] as const;

export type KinfeedTopicTagId = (typeof KINFEED_TOPIC_TAGS)[number]['id'];
export type KinfeedTopicFilter = 'all' | KinfeedTopicTagId;

export const KINFEED_TOPIC_FILTER_ALL: KinfeedTopicFilter = 'all';
export const KINFEED_MAX_TOPIC_TAGS = 2;

const KINFEED_TOPIC_TAG_SET = new Set<string>(KINFEED_TOPIC_TAGS.map((tag) => tag.id));

export const isKinfeedTopicTagId = (value: string): value is KinfeedTopicTagId =>
  KINFEED_TOPIC_TAG_SET.has(value);

export const normalizeKinfeedTopicTags = (tags: string[] | null | undefined): KinfeedTopicTagId[] => {
  if (!tags?.length) {
    return [];
  }

  const seen = new Set<KinfeedTopicTagId>();

  for (const tag of tags) {
    if (!isKinfeedTopicTagId(tag) || seen.has(tag)) {
      continue;
    }

    seen.add(tag);

    if (seen.size >= KINFEED_MAX_TOPIC_TAGS) {
      break;
    }
  }

  return Array.from(seen);
};

export const getKinfeedTopicTag = (tagId: string | null | undefined) =>
  KINFEED_TOPIC_TAGS.find((tag) => tag.id === tagId) ?? null;

export const matchesKinfeedTopicFilter = (
  topicTags: string[] | null | undefined,
  selectedTopic: KinfeedTopicFilter,
) => {
  if (selectedTopic === KINFEED_TOPIC_FILTER_ALL) {
    return true;
  }

  return normalizeKinfeedTopicTags(topicTags).includes(selectedTopic);
};

export const filterItemsByKinfeedTopic = <T extends { topic_tags?: string[] | null }>(
  items: T[],
  selectedTopic: KinfeedTopicFilter,
) => items.filter((item) => matchesKinfeedTopicFilter(item.topic_tags, selectedTopic));
